import { defineStore } from "pinia";

export const useLoaderPageStore = defineStore('loaderPage', {
	state: () => ({
		loadPage: false
	}),
	getters: {
		isLoadPage: (state) => state.loadPage
	},
	actions: {
		showLoaderPage() {
			this.loadPage = true;
		},
		hideLoaderPage() {
			this.loadPage = false;
		}
	}
});